<ion-header>
  <app-product-tour-background />
  @if (!hide) {
    <div class="main-container app-content-max-width" [class.no-avatar]="!showAvatar">
      @if(appService.isMobile$ | async) {
        <app-header-mobile (navigateBack)="navigateBack.emit()" [showBackButton]="showBackButton" [customTitle]="customTitle" [showAvatar]="showAvatar" />
      } @else {
        <app-header-desktop />
      }
    </div>
  }
</ion-header>
